<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'Penilaian '+type" @back="urlBack()">
            <br>
            <common-training-header :user_hash="user_hash" :withUser="true" />
        </a-page-header>

        <a-card type="inner" size="small">
            <a-form-model :model="formData">
                <a-table
                    class="pcp-table"
                    :dataSource="items"
                    rowKey="hash"
                    :loading="loading"
                    :pagination="false"
                    bordered>

                    <a-table-column key="component" :title="outline !== 'paper' ? 'Komponen Penilaian ' + type : 'Komponen Penilaian'" width="15%" className="column-score">
                        <template slot-scope="record">
                            {{ record.objective }}
                        </template>
                    </a-table-column>

                    <a-table-column key="reason" title="Catatan Penilaian" className="column-score" >
                        <template slot-scope="record">
                            <a-form-model-item>
                                <a-textarea v-model="$data['formData']['score_reason_' + record.hash]" :default-value="record.scores[0] ? record.scores[0].score_reason : ''" auto-size>
                                    {{ record.scores[0] ? record.scores[0].score_reason : '' }}
                                </a-textarea>
                            </a-form-model-item>
                        </template>
                    </a-table-column>

                    <a-table-column-group class="column-score">
                        <span slot="title">{{ type }}</span>
                        <a-table-column key="score" title="Score" className="column-score">
                            <template slot-scope="record">
                                <a-form-model-item>
                                    <a-radio-group :default-value="record.scores[0] && parseInt(record.scores[0].raw_score)" @change="(e) => onChange(e, record.hash)" :key="record.hash">
                                        <a-radio :value="100">
                                            100
                                        </a-radio>
                                        <a-radio :value="95" style="margin-left: 10px">
                                            95
                                        </a-radio>
                                        <a-radio :value="90" style="margin-left: 10px">
                                            90
                                        </a-radio>
                                        <a-radio :value="85" style="margin-left: 10px">
                                            85
                                        </a-radio>
                                        <a-radio :value="80" style="margin-left: 10px">
                                            80
                                        </a-radio>
                                        <a-radio :value="75" style="margin-left: 10px">
                                            75
                                        </a-radio>
                                        <a-radio :value="70" style="margin-left: 10px">
                                            70
                                        </a-radio>
                                        <a-radio :value="65" style="margin-left: 10px">
                                            65
                                        </a-radio>
                                        <a-radio :value="60" style="margin-left: 10px">
                                            60
                                        </a-radio>
                                    </a-radio-group>
                                </a-form-model-item>
                            </template>
                        </a-table-column>
                    </a-table-column-group>

                    <a-table-column key="weight" title="BOBOT (%)" width="8%" className="column-score">
                        <template slot-scope="record">
                            <center>
                                {{ record.config.weight * 100 }}
                            </center>
                        </template>
                    </a-table-column>

                    <a-table-column key="final_score" title="Nilai Akhir" width="8%" className="column-score">
                        <template slot-scope="record">
                            <center>
                                <div v-if="record.scores[0] && parseInt(record.scores[0].raw_score)">
                                    {{ parseFloat(parseInt(record.scores[0].raw_score) * record.config.weight).toFixed(2) }}
                                </div>
                                <div v-else>
                                    0
                                </div>
                            </center>
                        </template>
                    </a-table-column>
                    <template slot="footer" slot-scope="record" className="column-right">
                        <a-row type="flex" justify="end">
                            <a-col :span="4">
                                100%
                            </a-col>
                            <a-col :span="2">
                                <center>&emsp;&emsp;{{ totResult }}</center>
                            </a-col>
                        </a-row>
                    </template>
                </a-table>

                <br>
                <a-row>
                    <a-col :span="3" :offset="1">
                        Nama Penguji:
                    </a-col>
                    <a-col :span="6" :offset="2">
                        <a-form-model-item>
                              <a-input v-model="formData.penguji" :default-value="this.$laravel.user.name"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="2" :offset="2">
                        <a-form-model-item>
                            <a-button
                                type="primary"
                                @click="handleSubmit"
                                :loading="processing"
                                :disabled="processing">
                                Submit
                            </a-button>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-card>
    </div>
</template>

<style>
th.column-score {
    text-align: center !important;
}
.ant-table-footer {
    text-align: right !important;
}
</style>

<script>
    export default {
        props: {
            outline: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            category_hash: {
                type: String,
                required: true
            },
            user_hash: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                form: this.$form.createForm(this),
                items: [],
                loading: false,
                processing: false,
                reason: '',
                formData: {
                    objectives: []
                },
                dataExists: [],
            }
        },
        created() {
            this.getItems()
        },
        methods: {
            getItems() {
                this.loading = true

                let params = this.activeModule.module.identifier == 'paper' ? null : {
                    params: {
                        outline: this.outline
                    }
                }

                this.$http
                    .get(this.routeUri('api.activity-scoring.objectives', {
                        category: this.category_hash,
                        user_hash: this.user_hash
                    }) + '?outline='+this.outline)
                    .then(response => {
                        this.items = response.data.objectives
                        this.items.map(item => {
                            if(item.scores[0]){
                                this.dataExists.push({
                                    objective: item.hash,
                                    score: item.scores[0].raw_score,
                                    score_reason: item.scores[0].score_reason
                                })
                            }

                            return item.scores[0] ? item.scores[0].raw_score : 0
                        }).reduce((a, b) => a + b, 0)
                    })
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false))
            },
            notulen(hash){
                let params = {
                    user: hash,
                    previous: this.getRoute()
                }

                window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.notulen.form') + '?' + this.$qs.stringify(params)
            },
            onChange(e, id) {
                let index = this.formData.objectives.findIndex(x => x.objective === id);

                if(index === -1){
                    this.formData.objectives.push({
                        objective: id,
                        score: e.target.value
                    })

                    return
                }

                this.formData.objectives[index].score = e.target.value

            },
            handleSubmit(e) {
                e.preventDefault(e)

                this.processing = true

                let dataExisting = this.dataExists
                let updatedData = this.formData.objectives
                let arrParamId = []
                let tempData = dataExisting.slice(0)

                updatedData.forEach(el => {
                    arrParamId.push(el.objective)

                    dataExisting.forEach(data => {
                        if(data.objective == el.objective){
                            el.score_reason = data.score_reason
                        }
                    })
                })

                tempData.forEach(el => {
                    if(arrParamId.includes(el['objective'])){
                        let removeIndex = dataExisting.map((item) => item['objective']).indexOf(el['objective'])
                        dataExisting.splice(removeIndex, 1)
                    }
                })

                this.formData.objectives = dataExisting.concat(updatedData)

                if (this.formData.objectives.length != this.items.length) {
                    this.$notification.error({
                        message: "Gagal proses",
                        description: "Data harus terisi semua."
                    })

                    this.processing = false
                    return false
                }

                this.formData.user_hash = this.user_hash
                if (!this.formData.penguji) {
                    this.formData.penguji = this.$laravel.user.name
                }
                this.formData.outline = this.outline

                this.formData.objectives.map((item) => {
                    if(this['formData']['score_reason_' + item.objective]){
                        item.score_reason = this['formData']['score_reason_' + item.objective]
                    }
                })
                this.$http.put(this.routeUri('api.activity-scoring.scoring'), this.formData)
                .then((response) => {
                    this.handleSuccessResponse(response.data)
                })
                .catch((error) => this.handleResponseError(error.response.data))
                .finally(() => this.processing = false)
            },
            handleSuccessResponse(data) {
                var successMessage = "Data berhasil diproses!"

                if (typeof data.successMessage != "undefined") {
                    successMessage = data.successMessage
                }

                this.$notification.success({
                    message: "Sukses!",
                    description: successMessage
                })
                setTimeout(() => location.reload(), 1000)
            },
            handleResponseError(data) {
                if (data.hasOwnProperty("errors")) {
                    for (let key in data.errors) {
                        this.$notification.error({
                            message: "Gagal proses " + key,
                            description: Object.values(data.errors[key])
                        })
                    }
                } else {
                    this.$notification.error({
                        message: "Gagal proses",
                        description: "Data tidak dapat diproses."
                    })
                }
            },
            urlBack(){
                if(this.outline === 'paper'){
                    window.location.href = this.routeUri('admin.paper.scoring')
                }else if(this.outline === 'proposal'){
                    window.location.href = this.routeUri('admin.project.scoring.proposal')
                }else if(this.outline === 'evaluation'){
                    window.location.href = this.routeUri('admin.evaluation.scoring')
                }else{
                    window.location.href = this.routeUri('admin.project.scoring.project_evaluation')
                }
            }
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            },
            totResult(){
                let total = 0
                this.items.forEach(item => {
                    if (item.scores[0] && item.scores[0].raw_score) {
                        let result = parseInt(item.scores[0].raw_score) * item.config.weight

                        total += result
                    }
                })

                return total
            }
        }
    }
</script>
